import { render, staticRenderFns } from "./bindmobile.vue?vue&type=template&id=3e8985c2&scoped=true&"
import script from "./bindmobile.vue?vue&type=script&lang=js&"
export * from "./bindmobile.vue?vue&type=script&lang=js&"
import style0 from "./bindmobile.vue?vue&type=style&index=0&id=3e8985c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8985c2",
  null
  
)

export default component.exports